import { configureTheme } from '@nyce/admin-kit/console';

/** The hub keeps its theme choice under its own `oph:` prefix (sessions use `oph:` too). */
export const THEME_KEY = 'oph:theme';
configureTheme({ storageKey: THEME_KEY });

export {
  applyTheme,
  readThemeChoice,
  resolveTheme,
  setThemeChoice,
  ThemeToggle,
  useTheme,
  type ThemeChoice,
} from '@nyce/admin-kit/console';
